import { Link } from 'react-router-dom';
import { site } from '../../site';
import { PageTitle } from '../PageTitle';
import { FacebookIcon } from './FacebookIcon';

const EMAIL_LINKS = [
  {
    label: 'General question',
    email: site.infoEmail,
    subject: 'Question for Dala',
    body: 'Questions about Dala, your account, or how the service works.',
  },
  {
    label: 'Partner with Dala',
    email: site.partnersEmail,
    subject: 'Partner with Dala',
    body: 'For merchants, organizations, and local partnership ideas.',
  },
  {
    label: 'Drive or sell with us',
    email: site.partnersEmail,
    subject: 'Join Dala',
    body: 'Questions about becoming a rider, driver, shopper, or merchant.',
  },
] as const;

function mailto(email: string, subject: string) {
  return `mailto:${email}?subject=${encodeURIComponent(subject)}`;
}

export function ContactPage() {
  return (
    <div className="bg-paper text-ink">
      <PageTitle>Contact us — dala</PageTitle>

      <section className="border-b border-ink/[0.07]">
        <div className="mx-auto grid max-w-6xl gap-10 px-5 py-14 md:grid-cols-[1.1fr_0.9fr] md:items-center md:px-8 md:py-20">
          <div>
            <p className="overline">Contact Dala</p>
            <h1 className="mt-3 max-w-xl text-4xl leading-tight md:text-5xl">
              We’re here to help.
            </h1>
            <p className="mt-4 max-w-xl text-[15px] font-medium leading-relaxed text-ink/60">
              Questions, feedback, or a local partnership idea? Write to us in
              Bisaya, Tagalog, or English.
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              <a
                href={mailto(site.infoEmail, 'Contact Dala')}
                className="btn-primary"
              >
                Email {site.infoEmail}
              </a>
              <a
                href={site.facebookUrl}
                target="_blank"
                rel="noreferrer"
                className="btn-outline gap-2"
              >
                <FacebookIcon />
                Visit us on Facebook
              </a>
            </div>
          </div>

          <aside className="rounded-frame bg-ink p-7 text-white md:p-9">
            <p className="overline !text-white/40">Already on a trip or order?</p>
            <h2 className="mt-3 text-2xl leading-tight">Use support in the app.</h2>
            <p className="mt-3 text-[14px] font-medium leading-relaxed text-white/60">
              Open Dala → Chat → Dala support. Include the trip or order so we
              can understand what happened.
            </p>
            <Link
              to="/support"
              className="mt-6 inline-flex text-sm font-extrabold text-mango hover:underline"
            >
              Visit Help &amp; Support
            </Link>
          </aside>
        </div>
      </section>

      <section>
        <div className="mx-auto max-w-6xl px-5 py-14 md:px-8 md:py-20">
          <p className="overline">What can we help with?</p>
          <div className="mt-6 grid gap-4 md:grid-cols-3">
            {EMAIL_LINKS.map((item) => (
              <a
                key={item.label}
                href={mailto(item.email, item.subject)}
                className="card group flex min-h-52 flex-col p-6 transition hover:-translate-y-0.5 hover:border-mango/50 hover:shadow-[0_16px_40px_-28px_rgba(20,22,43,0.45)]"
              >
                <h2 className="text-xl">{item.label}</h2>
                <p className="mt-3 text-[14px] font-medium leading-relaxed text-ink/60">
                  {item.body}
                </p>
                <span className="mt-auto pt-6 text-sm font-extrabold text-terracotta group-hover:underline">
                  {item.email} →
                </span>
              </a>
            ))}
          </div>

          <div className="mt-12 grid gap-4 rounded-frame bg-clay p-7 md:grid-cols-[0.8fr_1.2fr] md:gap-10 md:p-10">
            <div>
              <p className="overline">A useful message</p>
              <h2 className="mt-3 text-2xl leading-tight">Help us find the details.</h2>
            </div>
            <div className="text-[14px] font-medium leading-relaxed text-ink/65">
              <p>
                Include your name, the phone number on your Dala account, and a
                short description of what you need.
              </p>
              <p className="mt-3">
                For a trip or order, include its reference or a screenshot. Do
                not email passwords, SMS codes, or payment credentials.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
